import { IPriceType } from '../../types'
import {TApiEnums} from '../../../services/_common'
import { enumTransformer } from '../../../services/_common/utils'

export function parsePriceTypes(response: TApiEnums): IPriceType[] {
    return response.entities.map((item) => enumTransformer(item))
}